import type { FileSystemNode } from '../../../../types/fileSystem.js';
import type { RagTableType } from '../../../../types/rag.js';
import { FileSystemTile } from './Tile.jsx';

type Props = {
  tableData: RagTableType[];
  selectedFileIds: string[];
  onToggleFile: (file: RagTableType) => void;
  onUnselectTableRows: () => void;
  onOpenDeleteDialog: (rows: RagTableType[]) => void;
  onOpenEditPermissionsDialog: (document: RagTableType) => void;
  onOpenMoveDialog: (nodes: FileSystemNode[]) => void;
};

const FileSystemTileExplorer = ({
  tableData,
  selectedFileIds,
  onToggleFile,
  onOpenDeleteDialog,
  onUnselectTableRows,
  onOpenEditPermissionsDialog,
  onOpenMoveDialog,
}: Props) => {
  return (
    <div
      className="grid min-h-0 flex-1 auto-rows-min grid-cols-2 gap-2 overflow-y-auto"
      data-testid="tile-explorer"
    >
      {tableData.map((item) => (
        <FileSystemTile
          key={item.fileId}
          item={item}
          isSelected={selectedFileIds.includes(item.fileId)}
          onToggleSelect={onToggleFile}
          onOpenDeleteDialog={onOpenDeleteDialog}
          onUnselectTableRows={onUnselectTableRows}
          onOpenEditPermissionsDialog={onOpenEditPermissionsDialog}
          onOpenMoveDialog={onOpenMoveDialog}
        />
      ))}
    </div>
  );
};

export { FileSystemTileExplorer };
